import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductRoutingModule } from './product-routing.module';
import { ProductGeneralComponent } from './product-general/product-general.component';
import { ProductTrainingMaterialsComponent } from './product-training-materials/product-training-materials.component';
import { ProductMarketingMaterialsComponent } from './product-marketing-materials/product-marketing-materials.component';
import { ProductCompetitorsComponent } from './product-competitors/product-competitors.component';
import { ProductReferencesComponent } from './product-references/product-references.component';
import { ProductProposalComponent } from './product-proposal/product-proposal.component';
import { ProductComponent } from './product/product.component';
import { MaterialsModule } from '../materials/materials.module';
import { AddReferenceComponent } from './product-references/add-reference/add-reference.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ReferenceDetailsComponent } from './product-references/reference-details/reference-details.component';
import { AddEditCompetitorComponent } from './product-competitors/add-edit-competitor/add-edit-competitor.component';
import { AddEditMaterialComponent } from './product-training-materials/add-edit-material/add-edit-material.component';
import { MaterialDetailsComponent } from './product-training-materials/material-details/material-details.component';
import { AddEditProposalComponent } from './product-proposal/add-edit-proposal/add-edit-proposal.component';
import { ValueProposalDetailsComponent } from './product-proposal/value-proposal-details/value-proposal-details.component';
import { CompetitorPositioningComponent } from './competitor-positioning/competitor-positioning.component';
import { AddEditPositioningComponent } from './competitor-positioning/add-edit-positioning/add-edit-positioning.component';
import { ChallengeDetailsComponent } from './competitor-positioning/challenge-details/challenge-details.component';
import { ProductSubscriptionsComponent } from './product-subscriptions/product-subscriptions.component';
import { EllipsisTooltipDirective } from '../shared/directives/ellipsis-tooltip.directive';

@NgModule({
  declarations: [ProductGeneralComponent,
                 ProductTrainingMaterialsComponent,
                 ProductMarketingMaterialsComponent,
                 ProductCompetitorsComponent,
                 ProductReferencesComponent,
                 ProductProposalComponent,
                 ProductComponent,
                 AddReferenceComponent,
                 ReferenceDetailsComponent,
                 AddEditCompetitorComponent,
                 AddEditMaterialComponent,
                 MaterialDetailsComponent,
                 CompetitorPositioningComponent,
                 AddEditPositioningComponent,
                 ChallengeDetailsComponent,
                 AddEditProposalComponent,
                 ValueProposalDetailsComponent,
                 ProductSubscriptionsComponent],
  imports: [
    CommonModule,
    ProductRoutingModule,
    MaterialsModule,
    ReactiveFormsModule,
    FormsModule,
    EllipsisTooltipDirective
  ]
})
export class ProductModule { }
